import { EToastStatus } from 'configs/enums';
import Messages from 'configs/messages';
import { ToastOptions, toast } from 'react-toastify';

interface ToastProps {
  status: EToastStatus;
}

const getTypeToast = (status: EToastStatus) => {
  switch (status) {
    case EToastStatus.Info:
      return toast.TYPE.INFO;
    case EToastStatus.Error:
      return toast.TYPE.ERROR;
    case EToastStatus.Success:
      return toast.TYPE.SUCCESS;
    case EToastStatus.Warning:
      return toast.TYPE.WARNING;
    default:
      return toast.TYPE.INFO;
  }
};

const show = (message: React.ReactNode, props: ToastProps) => {
  const options: ToastOptions = {
    autoClose: 5000,
    type: getTypeToast(props?.status),
    hideProgressBar: true,
    position: toast.POSITION.TOP_CENTER,
    pauseOnHover: true,
    className: 'toast-grade',
  };
  toast(message, options);
};

const error = (message: any, props?: ToastProps) => {
  const messageShow =   message?.detail || message?.message || message?.error || message || Messages.error.default;
  show(messageShow, { ...props, status: EToastStatus.Error });
};

const success = (message: React.ReactNode, props?: ToastProps) => {
  show(message, { ...props, status: EToastStatus.Success });
};

const info = (message: React.ReactNode, props?: ToastProps) => {
  show(message, { ...props, status: EToastStatus.Info });
};

const warning = (message: React.ReactNode, props?: ToastProps) => {
  show(message, { ...props, status: EToastStatus.Warning });
};

const ToastService = { error, success, info, warning };

export default ToastService;
